import React from "react";
import "./RequestModal.css";
import CourierShipmentSuccess from "../Dashboard/Users/Modals/CourierShipmentSuccessModal";

const RequestModal = ({ show, onClose, loading, error, courier, data }) => {
  if (!show) {
    return null;
  }


  return (
    <div className="req-modal-overlay">
      <div className="req-modal">
        {loading ? (
          <div className="modal-loading">
            <div className="spinner"></div>
            <p>Submitting your request...</p>
          </div>
        ) : error ? (
          <div className="error-div" >
            <h2 className="text-danger">Error</h2>
            <p className="text-danger error-message">{error}</p>
          </div>
        ) : courier && Array.isArray(data?.rates) && data.rates.length > 0 ? <CourierShipmentSuccess data={data} />  : (
         null
        )}
        { !loading && <button className="close-modal" onClick={onClose}>
          &times;
        </button> }
        
      </div>
    </div>
  );
};

export default RequestModal;
